var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard pt-0.5"},[_c('div',[_c('div',{staticClass:"flex flex-wrap"},[_c('div',{staticClass:"w-full laptop:p-3"},[_c('DashboardStatistic',{})],1)]),_c('div',{staticClass:"laptop:m-3"},[_c('DashboardChart')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }